import { default as React } from 'react';
import { useGlobalization } from '../../contexts/GlobalizationProvider';
import StylovyzeComposableDialog from '../StylovyzeComposableDialog';
import { List, ListItem, MessageText } from './Messages.styles';

interface UserTeamAccessProps {
	hasInfo360Licenses: boolean | null;
	projectsExists: boolean | null;
	hubExists: boolean | null;
	isLandingPage?: boolean;
}

export default function VerifyUserTeamAccessDialog({
	hasInfo360Licenses,
	projectsExists,
	hubExists,
	isLandingPage = false,
}: UserTeamAccessProps) {
	const { t } = useGlobalization();
	const shouldRenderMissingText =
		!hasInfo360Licenses || !projectsExists || !hubExists;
	return (
		<div data-testid="verify-user-access-dialog">
			<StylovyzeComposableDialog
				title={t('No access assigned')}
				open={true}
				onCancel={() => void 0}
				dialogProps={{
					container: () => document.getElementById('inno-app-body'),
					style: { position: 'relative', width: '100%' },
					BackdropProps: { style: { position: 'absolute' } },
				}}>
				{shouldRenderMissingText && !isLandingPage && (
					<MessageText data-testid="verify-user-team-access-text-wrapper">
						{t('You are missing:')}
						<List>
							{!hasInfo360Licenses && (
								<ListItem>{t('An assigned product')}</ListItem>
							)}
							{!projectsExists && (
								<ListItem>{t('An assigned project')}</ListItem>
							)}
							{!hubExists && (
								<ListItem>{t('An activated hub')}</ListItem>
							)}
						</List>
					</MessageText>
				)}
				<MessageText>
					{t('Please, contact your administrator or ')}
					<a
						href="https://www.autodesk.com/support/contact-support "
						target="_blank"
						rel="noopener noreferrer">
						{t('Autodesk support')}
					</a>
					.
				</MessageText>
			</StylovyzeComposableDialog>
		</div>
	);
}
